(function () {
    'use strict';

    var App = angular.module('myApp');
    App.controller('FooterController', function ($rootScope, $scope, $http, $state, $timeout, $loading, apiService, toastr) {

        var vm = this;
        $scope.profile = {};
        vm.textApp = textApp;

        function textApp(phoneNumber, valid) {
            if (valid) {
                console.log("in text me app link", phoneNumber);
                $loading.start('footerLink');
                apiService.textApp(phoneNumber)
                    .then(function (response) {
                        $loading.finish('footerLink');
                        vm.phoneNumber = '';
                        if (response) {
                            vm.responseData = response.data;
                            toastr.success(response.message);
                        }
                    })
                    .catch(function (error) {
                        $loading.finish('footerLink');
                        if (error.message) {
                            toastr.error(error.message);
                        }
                    });
            } else {
                if (phoneNumber == undefined || phoneNumber == null || phoneNumber == '') {
                    toastr.error('Please enter a phone number');
                } else {
                    toastr.error('Please enter a valid phone number');
                }
            }
        }
    });
})();